



















































































































































































import Vue from 'vue'
import { mapGetters } from 'vuex'

import { bus } from '../main'

import { PaymentCalculatorService } from '../services/PaymentCalculatorService'

/* eslint-disable */ 
import { Option } from '../models/Option'
import { OrderItem } from '../models/OrderItem'
import { Product } from '../models/Product'
/* eslint-enable */

import EmailDialog from '../components/EmailDialog.vue'
import TermsForm from '../components/TermsForm.vue'

export default Vue.extend({
  data () {
    return {
      tab: 0 as number,
      tabs: [
      'Product Details'
      ],
      options: [
        'Installed Price', 'Accessory Only - No additional cost'
      ],
      value: '' as string,
      quantity: 1 as number,
      emailDialog: false as boolean,
      termsDialog: false as boolean,
      selectedOptions: [] as Option[],
      window: window,
      snackbar: false,
      snackbarText: ''
    }
  },
  computed: {
     ...mapGetters({
      auth: 'auth/authenticated',
      currentTrim: 'trims/currentTrim',
      currentDealer: 'dealers/currentDealer',
      frequency: 'terms/currentFrequency',
      financeOptions: 'terms/financeOptions',
      leaseOptions: 'terms/leaseOptions',
      loading: 'products/loading',
      product: 'products/selectedProduct',
      rate: 'terms/rate',
      term: 'terms/term',
      currentUser: 'auth/currentUser',
      make: 'makes/currentMake'
    }),
    cols() : number {
      const { xs, sm } = this.$vuetify.breakpoint
      return (xs || sm) ? 12 : 6
    },
    currentDealerId() : number {
      return this.currentDealer.id
    },
    currentUserId() : number {
      return this.auth ? this.currentUser.id : -1
    },
    hasOptions() : boolean {
      return this.product.options.length > 0
    },
    useInstallPrice() : boolean {
      return this.currentDealer.onlyInstallPrice == 1 || this.value == 'Installed Price'
    },
    // This is the default installed price per product
    installedPrice() : number {
      return this.product.installPrice
    },
    package() : boolean {
      return this.product.products.length > 0
    },
    paymentPeriods() : number {
      return PaymentCalculatorService.getPaymentPeriods(this.frequency)
    },
    payment() : number {
      return PaymentCalculatorService.calculatePayment(this.rate, this.totalProductPrice, this.paymentPeriods, this.term)
    },
    productOptions() : any {
      const prodOpts : any = {}
      this.product.options.forEach((element : any) => {
        const opt = new Option(element)
        if (!(opt.optionType in prodOpts)) {
          prodOpts[opt.optionType] = [{ id: opt.id, name: opt.name, number: opt.number, price: opt.price }]
        } else {
          prodOpts[opt.optionType].push({ id: opt.id, name: opt.name, number: opt.number, price: opt.price })
        }
      })
      return prodOpts
    },
    // This is the default price per product
    productPrice() : number {
      return this.product.price
    },
    optionsPrice() : number {
      return this.selectedOptions.reduce(function (acc, obj) { 
        return obj !== undefined ? acc + obj.price : acc + 0 
        }, 0)
    },
    optionIds() : number[] {
      const arr = this.selectedOptions.map(function (obj) {
        return obj.id
      })

      return arr
    },
    // This is the total price, options included, for the product
    totalProductPrice() : number {
      const price = this.useInstallPrice ? this.installedPrice : this.productPrice
      const optionsTotal = this.optionsPrice
      return price + optionsTotal
    },
    productOptionArray() : any {
      return this.selectedOptions
    },
    productId() : number {
      return Number.parseInt(this.$route.params.productId)    
    },
    tabContent() : string[] {
      if (this.product) {
        return [
          this.product.detail
        ]
      }
      return [
        "No description for this product."
      ]
    }
  },
  methods: {
    addToCart() : void {
      const orderItem = new OrderItem({ productId: this.product.id, trimId: this.currentTrim.id, name: this.product.name, number: this.product.number, installed: this.useInstallPrice, quantity: this.quantity, price: this.productPrice, installedPrice: this.installedPrice, optionPrice: this.optionsPrice, total: this.totalProductPrice * this.quantity, options: this.optionIds, images: this.product.images })

      if (this.quantity > 0) {
        this.$store.dispatch('cart/updateCartWithProduct', { orderItem: orderItem, auth: this.auth, trimId: this.currentTrim.id, customerId: this.currentUserId })
      }
      bus.$emit('openCartDrawer')
    },
    back() : void {
      this.$router.push('/' + this.$route.params.makeId + '/' + this.$route.params.dealerCode + '/products')
    },
    closeEmailDialog(status: number) : void {
      this.emailDialog = false
      if (status !== 3) {
        status === 1 ? this.snackbarText = 'Email successfully sent!' : this.snackbarText = 'There was an error sending the email.'
        this.snackbar = true
      }
    },
    loadProductFromApi(productId : number, currentDealerId: number) : void {
      this.$store.dispatch('products/loadProduct', { productId: productId, dealerId: currentDealerId })
    },
    termsModal() : void {
      this.termsDialog = true
    },
    selectProductLink(product: Product) {
      this.$store.commit('products/setSelectedProduct', product)
      this.$router.push('/' + this.$route.params.makeId + '/' + this.$route.params.dealerCode + '/products/' + product.id)
    }
  },
  mounted () {
    if(!this.product || this.product.id != this.productId) {
      this.loadProductFromApi(this.productId, this.currentDealerId)
    }
  },
  components: {
    EmailDialog,
    TermsForm
  },
})
